import { interfaceURL } from '@/config/index';
/*
 ** 0 智能随访
 ** 1 智能表单
 ** 2 诊后计划
 */
export enum SourceType {
  followUp,
  issueForm,
  afterDiagnosisPlan,
}

// 计划状态
export enum FollowUpStatus {
  process = '1', // 随访中
  suspend = '2', // 暂停中
}

/* 患者详情来源类型
 **数据平台的患者列表跳转的，则source值为patient
 **智能随访，source值为followUp
 **诊后计划，source值为afterDiagnosisPlan
 **智能表单，source值为issueForm
 **宁夏肿瘤早筛，source为tumorEarlyScreen
 **试验报名，source为testPatient
 **意向登记，source为intentRegister
 **首页，source为workbench
 **专病库数据，source为sdlData（科研工具->专病库->数据）
 **专病库患者数据，source为sdlPatientData（科研工具->专病库->患者->患者姓名）
 */
export enum PatientDetailSourceType {
  dataPlatform = 'patient',
  followUpPlan = 'followUp',
  tumorEarlyScreen = 'tumorEarlyScreen',
  issueForm = 'issueForm',
  afterDiagnosisPlan = 'afterDiagnosisPlan',
  testRegistration = 'testPatient',
  intentToRegister = 'intentRegister',
  toolsInHospital = 'toolsInHospital',
  workbench = 'workbench',
  prepareVisit = 'prepareVisit',
  prepareVisitReport = 'prepareVisitReport',
  sdlData = 'sdlData',
  sdlPatientData = 'sdlPatientData',
}
export const SourceRelationDetail = {
  [SourceType.followUp]: PatientDetailSourceType.followUpPlan,
  [SourceType.afterDiagnosisPlan]: PatientDetailSourceType.afterDiagnosisPlan,
};

/* 消息类型
 ** 0 全部分类  1 即时消息
 ** 2 链接内容  3 患教内容
 ** 4 下发表单 5 结果页输出
 ** 6 随访 7 诊后计划
 ** 8 短信下发 9 加入子计划
 ** 10 终止计划 11 终止触发问卷
 ** 12 启动触发问卷
 ** 13 path地址 14 终止子计划
 */
export enum MessageType {
  allCategories,
  instantMessage,
  linksContent,
  customMessage,
  issueForm,
  resultLog,
  followUp,
  afterDiagnosisPlan,
  messageSend,
  joinChildPlan,
  stopPlan,
  stopTriggerQuestionnaire,
  startTriggerQuestionnaire,
  pathAddress,
  stopChildPlan
}

// 消息类型集合
export const MESSAGE_TYPE_ARRAY = [
  {
    value: MessageType.allCategories,
    label: '全部分类',
  },
  {
    value: MessageType.instantMessage,
    label: '即时消息',
  },
  {
    value: MessageType.linksContent,
    label: '链接内容',
  },
  {
    value: MessageType.customMessage,
    label: '患教内容',
  },
  {
    value: MessageType.issueForm,
    label: '下发表单',
  },
  {
    value: MessageType.resultLog,
    label: '结果页输出',
  },
  {
    value: MessageType.followUp,
    label: '下发随访',
  },
  {
    value: MessageType.afterDiagnosisPlan,
    label: '诊后计划',
  },
  {
    value: MessageType.messageSend,
    label: '仅发短信',
  },
  {
    value: MessageType.joinChildPlan,
    label: '加入子计划',
  },
  {
    value: MessageType.stopChildPlan,
    label: '终止子计划',
  },
  {
    value: MessageType.stopPlan,
    label: '终止计划',
  },
  {
    value: MessageType.stopTriggerQuestionnaire,
    label: '停止触发问卷',
  },
  {
    value: MessageType.startTriggerQuestionnaire,
    label: '执行触发问卷',
  },
  {
    value: MessageType.pathAddress,
    label: '跳转path地址',
  },
];

// 发送状态
export enum SendStatus {
  succeed = -1,
  withdraw = 1,
  Running = 2,
  partSucceed = 3,
  failed = 4,
  stop = 5,
}

/*
 ** 下发方式
 ** 0: 直接下发
 ** 1: 自动新增下发
 */
export enum DeliveryMethod {
  direct = 0,
  auto = 1,
}

export const MESSAGE_CN_STATUS = {
  [DeliveryMethod.direct]: {
    [SendStatus.succeed]: '完全成功',
    [SendStatus.withdraw]: '撤回',
    [SendStatus.Running]: '发送中',
    [SendStatus.partSucceed]: '部分成功',
    [SendStatus.failed]: '全部失败',
  },
  [DeliveryMethod.auto]: {
    [SendStatus.Running]: '运行中',
    [SendStatus.stop]: '停止',
  },
};
// 计分规则类型集合
export const SCORE_RULE_ARRAY = [
  {
    name: '无',
    exp: '无',
  },
  {
    name: '大于',
    exp: '>',
  },
  {
    name: '小于',
    exp: '<',
  },
  {
    name: '大于等于',
    exp: '>=',
  },
  {
    name: '等于',
    exp: '=',
  },
  {
    name: '小于等于',
    exp: '<=',
  },
  {
    name: '区间',
    exp: '~',
  },
  {
    name: '正常',
    exp: 'normal',
  },
];

// 表单下发状态 0:空表单，1:内容表单
export enum FormDeliveryState {
  emptyForm,
  contentsForm,
}

// 内镜报告描述
export const EndoscopicReportDescribe = {
  cardia: '贲门',
  descendingDuodenum: '十二指肠降部',
  duodenalBulb: '十二指肠球部',
  esophagus: '食管',
  fundusOfStomach: '胃底',
  gastricAntrum: '胃窦',
  gastricBody: '胃体',
  pylorus: '幽门',
  checkView: '大体所见',
};

// 内镜报告结论
export const EndoscopicReportConclusion = {
  MDAT: '镜下诊断',
  biopsySite: '活检部位',
  diagnosis: '主要病变及病理诊断',
};

// 病理报告
export const PathologicalReport = {
  MDAT: '主要病变及病理诊断',
  clinicalDiagnosis: '受到更多风格',
  generallySeen: '大体所见',
  malignantLesions: '是否恶性病变',
  precancerousLesions: '是否癌前病变',
};

// 心电图
export const ECGReport = {
  ClinicalDiagnosis: '临床诊断',
  P: 'P',
  QRS: 'QRS',
  QTOTC: 'QT/QTc',
  RV5SV1: 'RV5/SV1',
  heartRate: '心率',
};

/* 智能外呼
 ** 智能随访 1
 */
export enum IntelligentOutboundCall {
  intelligentFollowUp = 1,
}

//  1-拨号方 2-被叫方
export enum AsrFrom {
  dialer = 1,
  called = 2,
}

/*
 **
calling: 振铃
online: 已接通
over: 通话结束
 */
export enum CallStatus {
  calling = 'calling',
  online = 'online',
  over = 'over',
}

/*
 ** 患教宣传
 ** 修改类型 add：新增，modify:修改，delete：删除
 */
export enum EducationPublicityType {
  add = 'add',
  modify = 'modify',
  delete = 'delete',
}

/* 存储类型
 **0; 加密并私有读存储，需要通过存储服务间接访问（没有经过CDN）
 **1; 私有读存储，需要通过存储服务返回带签名的 CDN 链接访问
 **2; 公开读存储，可以直接通过 cos CDN 链接访问
 */
export enum StorageType {
  encryptPrivateReadStorage,
  privateReadStorage,
  openReadStorage,
}

export enum FileType {
  image = 'image',
  video = 'video',
  file = 'file',
}

// 文件上传大小限制（MB）
export const FILE_MAX_SIZE_MB = 20;

// 新增文件类型的 accept 扩展（不限制文件类型）
export const FILE_ACCEPT_TYPES = '*';

// 附件按钮 Tooltip 文案
export const ATTACHMENT_TOOLTIP_TEXT = '支持附件类型：图片、视频、文档、PDF、表格、PPT';

// 后端 fileType 枚举：1-文本(txt)，2-文档(word)，3-PDF，4-表格(xlsx)，5-PPT(pptx)
export enum BackendFileType {
  txt = 1,
  docx = 2,
  pdf = 3,
  xlsx = 4,
  pptx = 5,
}

// 文件扩展名 → 显示名 & 图标映射
export const FILE_TYPE_CONFIG: Record<string, { label: string; icon: string }> = {
  // 文本类
  txt: { label: '文本', icon: require('@/assets/images/file-icons/txt.png') },
  // Word 文档类
  doc: { label: '文档', icon: require('@/assets/images/file-icons/docx.png') },
  docx: { label: '文档', icon: require('@/assets/images/file-icons/docx.png') },
  // PDF
  pdf: { label: 'PDF', icon: require('@/assets/images/file-icons/pdf.png') },
  // 表格类
  xls: { label: '表格', icon: require('@/assets/images/file-icons/xlsx.png') },
  xlsx: { label: '表格', icon: require('@/assets/images/file-icons/xlsx.png') },
  csv: { label: '表格', icon: require('@/assets/images/file-icons/xlsx.png') },
  // PPT 类
  ppt: { label: 'PPT', icon: require('@/assets/images/file-icons/pptx.png') },
  pptx: { label: 'PPT', icon: require('@/assets/images/file-icons/pptx.png') },
};

// 未知文件类型的默认图标
export const FILE_UNKNOWN_ICON = require('@/assets/images/file-icons/unknown.png');

// 获取文件扩展名
export const getFileExtension = (fileName: string): string => {
  const parts = fileName.split('.');
  return parts.length > 1 ? parts.pop()!.toLowerCase() : '';
};

// 获取文件类型图标
export const getFileIcon = (fileName: string): string => {
  const ext = getFileExtension(fileName);
  return FILE_TYPE_CONFIG[ext]?.icon || FILE_UNKNOWN_ICON;
};

// 获取文件类型显示名
export const getFileTypeLabel = (fileName: string): string => {
  const ext = getFileExtension(fileName);
  return FILE_TYPE_CONFIG[ext]?.label || '文件';
};

export enum FormSource {
  patientEducation = 'patientEducation', // 患教宣传
}

// 打印图片样式
export const PRINT_IMAGE_STYLE = 'width:50%;display: block;max-height: 1000px;;margin:auto';

/*
 ** 0: 群发消息
 ** 1: 普通消息
 ** 2: 生成消息
 ** 4: 短信下发
 ** 5: 自动回复
 */
export enum MessageMode {
  massMessaging = '0',
  generalNews = '1',
  generateMessage = '2',
  SMSMessage = '4',
  autoReply = '5',
}

// 报告按时间或类型分类
export enum ReportClass {
  time,
  type,
}

/*
 **  计算规则类型
 **  健康贴士 tips
 **  建议 suggestion
 **  复杂计分 complexScore
 */
export enum ArithmeticRuleType {
  tips = 'tips',
  suggestion = 'suggestion',
  complexScore = 'complexScore',
}

export enum MsgTemplate {
  customMsg = 'customMsg',
  immediateMsg = 'immediateMsg',
  linkMsg = 'linkMsg',
  issueForm = 'issueForm',
  followUp = 'followUp',
  afterDiagnosisPlan = 'afterDiagnosisPlan',
  customMsgProject = 'customMsgProject',
}

// 消息类型和消息模板关系
export const MessageTypeRelationTemplate = {
  [MessageType.customMessage]: MsgTemplate.customMsg,
  [MessageType.instantMessage]: MsgTemplate.immediateMsg,
  [MessageType.linksContent]: MsgTemplate.linkMsg,
};

// 消息模板和消息类型关系
export const TemplateRelationMessageType = {
  [MsgTemplate.customMsg]: MessageType.customMessage,
  [MsgTemplate.immediateMsg]: MessageType.instantMessage,
  [MsgTemplate.linkMsg]: MessageType.linksContent,
  [MsgTemplate.customMsgProject]: MessageType.customMessage,
};

/*
 ** 0-周期计划(智能随访、诊后计划)
 ** 1-分组
 */
export enum TaskType {
  cyclePlan,
  group,
}

// 上传资源地址
export const UPLOAD_IMAGE_URL = `${interfaceURL}hospital/uploadImage`;

// 文件上传接口地址
export const UPLOAD_FILE_URL = `${interfaceURL}hospital/uploadfile`;

// 预览资源地址
export const DOWNLOAD_IMAGE_URL = `${interfaceURL}hospital/downloadImage/`;

export enum UserType {
  main = 'main',
  sub = 'sub',
  normal = 'normal',
  admin = 'admin',
  execute = 'execute',
  owner = 'owner',
}
// 患者管理所包含模块
export enum TabType {
  completeOverview, // 完成概览
  userPortrait, // 用户画像
  checkReport, // 报告上传
  specialDiseaseLibraryData, // 专病库数据
  pastHistory, // 患者病史
  timeLine, // 时间轴
  dialog, // 沟通
  testSignUp, // 试验报名
  intentRegister, // 意向登记
  outboundCall, // 外呼
  remarks, // 备注
  uploadedReport, // 用户上传数据
  extraFollowUp, // 额外随访(欣悦)
}

// 专病库患者列表默认分页条目数
export const SDL_PATIENT_SIZE = 20;

// 检查报告相关字段
export const CHECK_REPORTINFO_LIST = [
  { label: '检查描述', value: 'checkView' },
  { label: '检查结论', value: 'conclusion' },
];

// 心电图相关字段
export const ELECTRO_CARDIOGRAM_INFO_LIST = [
  { label: 'P', value: 'pDuration' },
  { label: 'P-QRS', value: 'p_QRS' },
  { label: 'QRS电轴', value: 'qrsAxis' },
  { label: 'QRS', value: 'qrsDuration' },
  { label: 'QT/OTc', value: 'qT_OTc_interval' },
  { label: 'RV5/SV1', value: 'rv5_SV1_amplitude' },
  { label: '心率', value: 'heartRate' },
  { label: 'P-R', value: 'pR' },
  { label: '临床诊断', value: 'ecgDiagnosis' },
];
// 病理报告相关字段
export const PATHOLOGY_REPORT_INFO_LIST = [
  { label: '病理描述', value: 'pathologyDesc' },
  { label: '病理诊断', value: 'pathologyConclusion' },
];

//  0:查询全部 1:系统标签 2:自定义标签
export enum TagSort {
  all,
  systemLabel,
  customLabel,
}

export const AI_MODEL_LIST = [
  {
    label: 'DeepSeek-R1',
    value: 'deepSeek',
  },
  {
    label: 'Hunyuan',
    value: 'hunyuan',
  },
];

// summary 健康总结, plan 健康计划 education 健康宣教 record 档案智问
export enum AIFunctionType {
  healthReport = 'summary',
  healthEducation = 'education',
  healthPlan = 'plan',
  healthRecord = 'patientArchiveChat',
}

// 门诊病历相关字段
export const MEDICAL_RECORD_INFO_LIST = [
  {
    label: '主诉',
    value: 'chiefComplaint',
  },
  {
    label: '现病史',
    value: 'diseasePresent',
  },
  {
    label: '既往史',
    value: 'diseaseHistory',
  },
  {
    label: '体格检查',
    value: 'physicalExamination',
  },
  {
    label: '诊断',
    value: 'clinicalDiagnosis',
  },
  {
    label: '处理',
    value: 'treatmentSuggestion',
  },
  {
    label: '医嘱',
    value: 'advice',
  },
];
// 出院报告相关字段
export const DISCHARGE_REPORT_INFO_LIST = [
  {
    label: '住院日期',
    value: 'admissionTime',
  },
  {
    label: '出院日期',
    value: 'dischargeTime',
  },
  {
    label: '住院天数',
    value: 'admissionDays',
  },
  {
    label: '入院诊断',
    value: 'admissionDiagnosis',
  },
  {
    label: '出院诊断',
    value: 'dischargeDiagnosis',
  },
  {
    label: '入院时情况',
    value: 'admissionCondition',
  },
  {
    label: '治疗经过',
    value: 'checkAndTreatmentProcess',
  },
  {
    label: '出院时情况',
    value: 'dischargeCondition',
  },
  {
    label: '出院医嘱',
    value: 'dischargeInstructions',
  },
];
/*
 ** 0 手术名称列表
 ** 1 手术编码
 ** 2 麻醉方式
 ** 3 诊断编码
 ** 4 诊断名称
 ** 5 科室名称列表
 ** 6 医生名称列表
 */
export const codeDictionary = {
  surgeryName: 0,
  surgeryCode: 1,
  anesthesiaType: 2,
  diagnosisCode: 3,
  diagnosisName: 4,
  departmentName: 5,
  doctorName: 6,
};

// 表单类型
export enum FormType {
  once = '0',
  repeat = '1',
}

// 表单类型中文映射
export const FORM_TYPE_LABEL: Record<FormType, string> = {
  [FormType.once]: '一次性问卷',
  [FormType.repeat]: '重复性问卷',
};
export enum GenderType {
  unknown = -1,
  male = 0,
  female = 1,
}
export const genderMap = {
  [GenderType.unknown]: '-',
  [GenderType.male]: '男',
  [GenderType.female]: '女',
};

export enum CardType {
  IDCard = 0, // 身份证：18位身份证号码
  militaryID = 1, // 军官证：军/兵/政/文/职/广/（其他中文）+字第+4~8位数字
  householdRegister = 2, // 居民户口簿：18位身份证号码
  ChineseMainlandPassport = 3, // 中国大陆地区护照：一共9位，首字母+8位字母/数字。
  ChineseHongkongMacaoAndTaiwanPassports = 4, // 中国港澳台地区护照：一共9位，包括首字母和数字。
  foreignPassport = 5, // 外国护照：基本为9位数，部分存在：00No.0000000 样式，前端可暂时不校验外国护照
  driversLicense = 6, // 驾驶证：18位身份证号码
  HongkongAndMacaoToMainlandPass = 7, // 港澳居民来往内地通行证：一位H或M字母和8位阿拉伯数字
  TaiwanToMainlandPass = 8, // 台湾居民来往大陆通行证：8位阿拉伯数字
  birthCertificate = 9, // 出生医学证明：一位英文字母+9位阿拉伯数字
  foreignPermanentResidentIDCard = 10, // 外国人永久居住证：18位居住证号码
  other = 11, // 其他法定有效证件
  PhoneNumber = 12, // 手机号进行实名认证方式
}
/**
 * 0 患者上传
 * 1 医生上传
 * 2 同步，患者也可查看
 */
export enum DoctorCustomStatus {
  patientUpload = 0,
  uploadedByDoctor = 1,
  viewAlso = 2,
}

export const SYNC_PATIENT_LIST = [
  {
    label: '同步，患者也可查看',
    value: DoctorCustomStatus.viewAlso,
  },
  {
    label: '不同步，仅医生端查看',
    value: DoctorCustomStatus.uploadedByDoctor,
  },
];

// 验光类型选项
export const OPTOMETRY_TYPE_OPTIONS = [{
  label: '散瞳验光',
  value: '散瞳验光',
}, {
  label: '普通验光',
  value: '普通验光',
}];

// 验光单
export const OPTOMETRY_FIELD_LIST = [
  { label: '球镜（S/DS）', rightField: 'rightSphere', leftField: 'leftSphere' },
  { label: '柱镜 (C/DC）', rightField: 'rightCylinder', leftField: 'leftCylinder' },
  { label: '轴位 (A/AXIS', rightField: 'rightAxis', leftField: 'leftAxis' },
];

// 眼球生物测量仪报告
export const BIOMETRY_INDICATOR_LIST = [
  { name: '眼轴 (AL)', field: 'al' },
  { name: '角膜曲率：平K (K1)', field: 'k1' },
  { name: '角膜曲率：陡K (K2)', field: 'k2' },
  { name: '角膜散光 (CYL)', field: 'cyl' },
  { name: '平K的曲率半径 (R1)', field: 'r1' },
  { name: '陡K的曲率半径 (R2)', field: 'r2' },
  { name: '白到白 (WTW)', field: 'wtw' },
  { name: '中央角膜厚度 (CCT)', field: 'cct' },
  { name: '前房深度测量 (ACD)', field: 'acd' },
];
